const cusUtilFn = {
  /***
   * 鄂汇办获取当前的基路径
   */
  getRootPath(){
    var curPageUrl = window.document.location.href;
    var url=curPageUrl.split('#')[0];
    var rootPath = url+'#'
    return rootPath;
  },
  /**普通页面跳转 */
  /**11位手机号码检测,0-为空,1-手机号格式错,2-手机号正确*/
  isPhoneAvailable(phone) {
    let reg1 = /^1[345789]\d{9}$/;
    if (!phone) {
      return 0;
    } else if (!reg1.test(phone)) {
      return 1;
    }else {
      return 2;
    }
  },
  /**座机号码检测,0-为空,1-座机格式错,2-座机正确*/
  isFixedTelAvailable(tel) {
    let reg2 = /^(0\d{2,3}-)?\d{7,8}$/;
    if (!tel) {
      return 0;
    } else if (!reg2.test(tel)) {
      return 1;
    } else {
      return 2;
    }
  },
  /**手机号码/座机检测,0-为空,1-格式错,2-正确*/
  isPhoneorFixedTelAvailable(phone) {
    let reg1 = /^1[345789]\d{9}$/;
    let reg2 = /^0\d{2,3}-[1-9]\d{6,7}$/;
    if (!phone) {
      return 0;
    } else if (reg1.test(phone)||reg2.test(phone)) {
      return 2;
    }else {
      return 1;
    }
  },
  /**姓名,正则：大于2位小于等于32位字符,0-为空,1-格式错,2-正确*/
  isName(name) {
    let reg = /^[\u4E00-\u9FA5\·]{2,32}$/;
    if (!Boolean(name)||!name.length) {
      return 0;
    }else if(reg.test(name) === false){
      return 1
    } else return 2;
  },
  /**身份证,0-为空,1-格式错,2-正确*/
  isCardNo(card) {
    let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
    if (!Boolean(card)||!card.length) {
      return 0;
    }else if(reg.test(card) === false){
      return 1
    } else return 2;
  },
  /**获取url参数 */
  getUrlQueryString(url) {
    var reg = new RegExp("(^|&)" + url + "=([^&]*)(&|$)");
    var r = decodeURI(window.location.search.substr(1)).match(reg);
    if (r != null)return unescape(r[2]);
    return null;
  },
  /**
   * 字符串****隐藏
   * frontLen：前面保留位数
   * endLen：后面保留位数
   * starLen:中间*显示位，不填则默认str长度-frontLen-endLen
   */
  hideByplusXing(str, frontLen, endLen, starLen) {
    if (!str) return false;
    let len = str.length - frontLen - endLen;
    starLen = starLen || len;
    let xing = "";
    for (var i = 0; i < starLen; i++) {
        xing += "*";
    }
    return (
        str.substring(0, frontLen) +
        xing +
        str.substring(str.length - endLen)
    );
}


}


export default cusUtilFn;